import { AbstractFrameTrigger } from "./AbstractFrameTrigger.js";
class FrameAnchor extends AbstractFrameTrigger {
  /**
   * Config.
   */
  static config = {
    name: "FrameAnchor"
  };
  /**
   * Prevent click.
   */
  onClick({ event }) {
    if (!event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey && event.button === 0 && this.$el.target !== "_blank") {
      event.preventDefault();
      this.trigger();
    }
  }
}
export {
  FrameAnchor
};
//# sourceMappingURL=FrameAnchor.js.map
